import type { AuthUser } from '@/api/auth';
import { userSections } from './studentFields';

/**
 * Кому в приложении положены пуши (решение владельца 01.10.2026).
 *
 * Только ученику с куратором. Пушем уходят два события — «Куратор оценил урок» и «Куратор проверил ДЗ»
 * (`docs/CONTRACTS/push.md`): у ученика без куратора их не бывает. Спросить у него разрешение значило бы
 * задать вопрос, за которым ничего не стоит, — а система задаёт его ОДИН раз за установку.
 *
 * ⚠️ ПРИЗНАК — РАЗДЕЛ `chat` В `sections`. Это и есть «раздел с куратором»: сверено на копии прода 01.10.2026 —
 * он есть у 29 платных курсов (2711 записей), нет только у пяти курсов «ONE SELF» без куратора (107 записей) и у
 * бесплатного набора (`lessons, vocab`). Самого чата в приложении нет — раздел здесь служит признаком, не экраном.
 *
 * ⚠️ СТРОГО: нет набора — пушей нет (как всё приложение, D75). Куратор и админ — нет: оба события адресованы
 * ученику, а оболочку ученика админ открывает тоже.
 *
 * Единственное место этого правила: по нему и спрашиваем разрешение, и отдаём метку, и рисуем тумблер.
 */
export function canHavePush(user: AuthUser | null | undefined): boolean {
  if (!user || user.role !== 'student') return false;
  const sections = userSections(user);
  return !!sections && (sections.includes('*') || sections.includes('chat'));
}
